'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = TeamSizeSelect;

require('./team-size-select.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _scooter_icon = require('./assets/scooter_icon.svg');

var _scooter_icon2 = _interopRequireDefault(_scooter_icon);

var _car_icon = require('./assets/car_icon.svg');

var _car_icon2 = _interopRequireDefault(_car_icon);

var _boat_icon = require('./assets/boat_icon.svg');

var _boat_icon2 = _interopRequireDefault(_boat_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function TeamSizeSelect(p) {

    var baseClass = 'team-size-level';
    var selectedClass = ' selected';

    var individualLevel = _react2['default'].createElement(
        'div',
        {
            className: p.selected === 'individual' ? baseClass + selectedClass : baseClass,
            onClick: function onClick() {
                return p.onTeamSizeSelect('individual');
            } },
        _react2['default'].createElement('img', { src: _scooter_icon2['default'] }),
        _react2['default'].createElement(
            'div',
            { className: 'level-name' },
            'Individual'
        )
    );

    var smallTeamLevel = _react2['default'].createElement(
        'div',
        {
            className: p.selected === 'small-team' ? baseClass + selectedClass : baseClass,
            onClick: function onClick() {
                return p.onTeamSizeSelect('small-team');
            } },
        _react2['default'].createElement('img', { src: _car_icon2['default'] }),
        _react2['default'].createElement(
            'div',
            { className: 'level-name' },
            'Small team'
        )
    );

    var largeTeamLevel = _react2['default'].createElement(
        'div',
        {
            className: p.selected === 'large-team' ? baseClass + selectedClass : baseClass,
            onClick: function onClick() {
                return p.onTeamSizeSelect('large-team');
            } },
        _react2['default'].createElement('img', { src: _boat_icon2['default'] }),
        _react2['default'].createElement(
            'div',
            { className: 'level-name' },
            'Large team'
        )
    );

    return _react2['default'].createElement(
        'div',
        { className: 'm-team-size-select' },
        individualLevel,
        smallTeamLevel,
        largeTeamLevel
    );
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/choose-signup-plan/v2/team-size-select.jsx
 ** module id = 1162
 ** module chunks = 0
 **/